
import ImageWithLoader from "../../shared/imageWithLoader/ImageWithLoader"
import type { ImageSizeVariant } from "@/app/lib/image-sizes"

type GalleryItem = { src: string; alt: string }

const NeighborhoodsCol = ({
	isFeatured,
	isFullHeight,
	item,
}: {
	isFeatured: boolean
	isFullHeight: boolean
	item: GalleryItem
}) => {
	const sizeVariant: ImageSizeVariant = isFeatured
		? "galleryTileFeatured"
		: "galleryTile"

	const heightClass = isFullHeight
		? "h-full"
		: isFeatured
			? "h-[69%] lg:h-[70%]"
			: "h-[29%] lg:h-[30%]"

	return (
		<div className={`neighborhoods_gallery_container relative ${heightClass}`}>
			<ImageWithLoader
				src={item.src}
				alt={item.alt}
				sizeVariant={sizeVariant}
				quality={85}
			/>
		</div>
	)
}

const GalleryColumn = ({
	items,
	reverse,
}: {
	items: GalleryItem[]
	reverse?: boolean
}) => {
	const single = items.length === 1

	return (
		<div
			className={`neighborhoods-col h-full flex ${
				reverse ? "flex-col-reverse" : "flex-col"
			} justify-between w-[50%] overflow-hidden lg:gap-2`}
		>
			{items.map((item, index) => (
				<NeighborhoodsCol
					key={`${item.src}-${index}`}
					item={item}
					// Lone image in a column fills the column (3-photo layout).
					isFullHeight={single}
					// First slot (or lone image) is the tall / featured tile.
					isFeatured={single || index === 0}
				/>
			))}
		</div>
	)
}

const NeighborhoodsGallery = ({ gallery }: { gallery: GalleryItem[] }) => {
	const left = gallery?.slice(0, 2) ?? []
	const right = gallery?.slice(2, 4) ?? []

	return (
		<div className="neighborhoods_gallery || w-[100%] h-full flex flex-row gap-2">
			<GalleryColumn items={left} />
			<GalleryColumn items={right} reverse />
		</div>
	)
}

export default NeighborhoodsGallery
